import { getFirAnalytics } from '../../Api/firebase/firebaseConnect'

export const logEvent = async (name: string, params?: any | undefined) => {
  try {
    const { logEvent: firLogEvent } = await import('firebase/analytics')
    const fa = await getFirAnalytics()
    firLogEvent(fa, name, params)
  } catch (error) {
    console.warn('Failed to log analytics event:', name, error)
  }
}
